import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export class ExecutiveSummaryRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      userSettings.hasPermissionToRead(Module.DASHBOARDEXECUTIVESUMMARIES) ||
      userSettings.hasPermissionToRead(Module.REPORTSTUDIOEXECUTIVESUMMARIES)
    );
  }
}
